import PropTypes from 'prop-types';
import React from 'react';
import WidgetActionComponent from '../../../../components/WidgetActionComponent';
import Card from '../../components/Card';
import CRSDataTable from './CRSDataTable';
import styles from './index.scss';

const CRSTableContainer = ({
  header,
  actions,
  onDateChange,
  dateRange,
  ...props
}) => {
  const onWidgetActionChange = (config) => {
    if (onDateChange) onDateChange(config.from, config.to);
  };
  //hide if isVisible is set to false in global settings
  if (props?.GSConfig?.isVisible === false) return null;
  return (
    <Card header={header} actions={actions}>
      <WidgetActionComponent
        size="small"
        hasDatePicker={true}
        hasDurationPicker={true}
        onChangeActions={onWidgetActionChange}
        dateRange={dateRange}
      />

      <div className={styles.tableContainer}>
        <CRSDataTable {...props} />
      </div>
    </Card>
  );
};

CRSTableContainer.propTypes = {
  GSConfig: PropTypes.object,
  actions: PropTypes.object,
  header: PropTypes.string,
  onDateChange: PropTypes.func,
  props: PropTypes.object,
  dateRange: PropTypes.object
};

export default CRSTableContainer;
